import { Component } from '@verndale/core';
import elementWithinViewport from 'element-within-viewport';
import { getTimesConfig, buildOptionsHtml } from '../helpers/times';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $inquire: document._$('.contact-us__inquire'),
      $submit: this.el._$('[type="submit"]'),
      $datePicker: this.el._$('duet-date-picker'),
      $timeSelect: this.el._$('.contact-us__time select'),
      $topics: this.el._$('.contact-us__topics'),
    };

    this.inViewportClass = 'contact-us--in-viewport';
    this.preferredTimesTopicValue = this.el.dataset.preferredTimesTopic;
    this.preferredTimesShownClass = 'contact-us--preferred-times-shown';

    this.dom.$datePicker.firstDayOfWeek = 0;
    this.wasValidated = false;

    this.timeHandler();
    this.checkIfIsInViewport();
  }

  addListeners() {
    this.dom.$topics._on('change', this.handleTopicChange.bind(this));
    this.dom.$datePicker.addEventListener('duetChange', event => {
      this.currentDate = event.detail.valueAsDate;
      this.timeHandler();
    });

    this.dom.$datePicker.addEventListener('duetBlur', () => {
      const $input = this.dom.$datePicker.querySelector('input');
      $input.value = this.dom.$datePicker.value;
    });
  }

  checkIfIsInViewport() {
    elementWithinViewport(this.dom.$submit, {
      threshold: -60,
      onEnter: () => {
        this.el.classList.add(this.inViewportClass);
      },
      onExit: () => {
        this.el.classList.remove(this.inViewportClass);
      }
    });
  }

  timeHandler() {
    this.dom.$timeSelect.innerHTML = '';

    const todayFormated = new Date().toLocaleString('sv', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).split(' ')[0].split('/').reverse().join('-');
    const isToday = this.dom.$datePicker.value === todayFormated;
    const today = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });

    const { parsedOptions, minDatePicker } = getTimesConfig(this.dom.$datePicker, isToday, today);
    this.dom.$datePicker.min = minDatePicker;

    if (parsedOptions.length === 1) {
      const $dateInput = this.dom.$datePicker.querySelector('.duet-date__input');
      const errorMessage = this.dom.$datePicker.dataset.pristineNoTimes;
      setTimeout(() => {
        $dateInput.pristine.errors = [];
        $dateInput.pristine.self.addError($dateInput, errorMessage);
      });
    }

    if (!this.wasValidated) {
      this.dom.$datePicker.value = minDatePicker;
      this.wasValidated = true;
      this.timeHandler();
      return;
    }

    const optionsHtml = buildOptionsHtml(parsedOptions);

    this.dom.$timeSelect.innerHTML = optionsHtml;
  }

  buildOptionsHtml(items) {
    return items
    .map(
      item => `
        <option value="${item.value}">${item.label}</option>
      `
    ).join('');
  }

  handleTopicChange(e) {
    const isShown = e.target.value === this.preferredTimesTopicValue;
    this.el.classList.toggle(this.preferredTimesShownClass, isShown)
    this.dom.$timeSelect.required = isShown;
  }
}

export default Module;
